import Constants from "../utils/consts";
import Cookies from "universal-cookie";

const REQUEST_TIMEOUT = 600000; // 10 minuti in millisecondi per file grandi

function getDbName() {
  try {
    return new Cookies().get("db", { path: "/" });
  } catch (error) {
    console.warn("[loadDocument] Impossibile leggere il cookie db:", error);
    return undefined;
  }
}

export default async function loadDocument(
  uname,
  token,
  corso,
  filename,
  filecontent,
  description,
  userId,
  onProgress // Callback per mostrare l'avanzamento
) {
  try {
    const db = getDbName();
    const endpoint = `${Constants.mainUrl}loadDocument.php`;

    // Stima dimensione originale
    const originalSize = filecontent.length;
    const originalSizeMB = (originalSize / 1024 / 1024).toFixed(2);

    console.log(
      `[loadDocument] File originale: ${originalSizeMB} MB (${filename})`
    );

    // Disabilito la compressione per ora - i PDF sono già compressi internamente
    // e comprimere ulteriormente il base64 causa problemi di decodifica
    const compressedContent = filecontent;
    const isCompressed = false;

    /*
    // NOTA: Compressione disabilitata perché:
    // 1. I PDF sono già compressi (riduzione solo 0.8%)
    // 2. Comprimere base64 causa errori di decodifica sul server
    // 3. Serve implementare compressione PRIMA della conversione base64
    
    // eslint-disable-next-line no-undef
    if (originalSize > 5 * 1024 * 1024 && typeof CompressionStream !== 'undefined') {
      try {
        console.log("[loadDocument] 🗜️ Compressione file in corso...");
        // ...logica di compressione...
      } catch (error) {
        console.warn("[loadDocument] ⚠️ Compressione fallita:", error);
      }
    }
    */

    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      params.append("token", token);
      params.append("uname", uname);
      if (db) params.append("db_name", db);
      params.append("id_corso", corso);
      params.append("filename", filename);
      params.append("filecontent", compressedContent);
      params.append("description", description ?? "");
      params.append("user_id", userId);
      // is_compressed rimosso - compressione disabilitata

      const payload = params.toString();
      const payloadSizeMB = (payload.length / 1024 / 1024).toFixed(2);

      console.log(
        `[loadDocument] Dimensione payload da inviare: ${payloadSizeMB} MB`
      );

      const xhr = new XMLHttpRequest();
      xhr.open("POST", endpoint, true);
      xhr.timeout = REQUEST_TIMEOUT;
      xhr.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
      );

      xhr.upload.onprogress = function(event) {
        if (!onProgress) return;

        if (event.lengthComputable && event.total > 0) {
          const percent = Math.min(
            99,
            Math.floor((event.loaded / event.total) * 100)
          );
          onProgress(percent);
        } else {
          // Fallback quando il browser non fornisce la lunghezza
          onProgress(50);
        }
      };

      xhr.onreadystatechange = function() {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;

        console.log("loadDocument response status:", xhr.status);
        console.log("loadDocument response body:", xhr.responseText);

        if (onProgress) {
          onProgress(100);
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const resp = JSON.parse(xhr.responseText);
            resolve(resp);
          } catch (error) {
            console.error("Error parsing loadDocument response:", error);
            reject({
              error: "PARSE_ERROR",
              message: "Errore nel parsing della risposta dal server",
              details: error.message,
            });
          }
        } else {
          reject({
            error: "HTTP_ERROR",
            status: xhr.status,
            message: "Errore dal server durante il caricamento",
            details: xhr.responseText,
          });
        }
      };

      xhr.onerror = function(event) {
        console.error("loadDocument network error:", event);
        reject({
          error: "NETWORK_ERROR",
          message: "Errore di rete durante l'upload",
        });
      };

      xhr.ontimeout = function() {
        console.error(
          "loadDocument timeout - Il caricamento ha superato il tempo massimo"
        );
        reject({
          error: "TIMEOUT",
          message:
            "Il caricamento del file ha richiesto troppo tempo. Riprova più tardi.",
        });
      };

      xhr.onabort = function() {
        console.warn("loadDocument upload abortito dall'utente");
        reject({
          error: "ABORTED",
          message: "Caricamento annullato",
        });
      };

      console.log("loadDocument sending data:", {
        token: token ? "presente" : "mancante",
        uname,
        db_name: db,
        id_corso: corso,
        filename,
        user_id: userId,
        description: description ? "presente" : "mancante",
        filecontent: filecontent ? "presente" : "mancante",
      });

      if (onProgress) {
        onProgress(0);
      }

      xhr.send(payload);
    });
  } catch (error) {
    console.error("[loadDocument] Errore generale:", error);
    throw error;
  }
}
